import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import { sendAlert } from '../../../actions/utils';
import { createOvertimeCompensationRequest } from '../../../requests/overtimeCompensations';
import OvertimeCompensationForm from './OvertimeCompensationForm';
import useOvertimeCompensationData from './useOvertimeCompensationData';

const OvertimeCompensationNew = ({ onSuccess, employeeId, rrhh = false, availableDays }) => {
  const basicOvertimeCompensation = {
    employeeId: '',
    startDate: '',
    endDate: '',
    status: '',
    rrhh
  };

  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const { overtimeEquivalence } = useOvertimeCompensationData(selectedEmployeeId);
  const dispatch = useDispatch();

  const handleEmployeeSelect = selectedId => {
    setSelectedEmployeeId(selectedId);
  };

  const handleCreateRequest = (overtimeCompensation, setSubmitting = () => null) => {
    const snakeCaseCompensation = snakeCaseKeys(overtimeCompensation);
    createOvertimeCompensationRequest({
      dispatch,
      params: {
        ...snakeCaseCompensation,
        direct_approve: rrhh
      },
      successCallback: () => {
        onSuccess('Solicitud creada con éxito');
        dispatch(sendAlert({ kind: 'success', message: 'Solicitud creada con éxito' }));
      },
      failureCallback: error => {
        console.error('Error al crear la solicitud:', error);
        setSubmitting(false);
      },
      callback: () => setSubmitting(false)
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Row>
      <Col>
        <OvertimeCompensationForm
          overtimeCompensation={{ ...basicOvertimeCompensation, employeeId, directApprove: rrhh }}
          action="new"
          onEmployeeSelect={handleEmployeeSelect}
          formRequest={handleCreateRequest}
          availableDays={selectedEmployeeId ? overtimeEquivalence : availableDays}
          rrhh={rrhh}
        />
      </Col>
    </Row>
  );
};

export default OvertimeCompensationNew;
